import { TwitterTweetEmbed } from "react-twitter-embed";
import * as React from 'react';
export default {
  TwitterTweetEmbed,
  React
};